import {
  Typography,
  Link,
  Grid,
  TextField,
  Select,
  FormControl,
  MenuItem,
  Button,
} from "@mui/material";
import React, { useState } from "react";

import FacebookIcon from "../assets/facebookIcon.png";

function Account(props) {
  const [submitted, setSubmitted] = useState(false);
  const [trafficChannel, setTrafficChannel] = useState("");
  const [referrerEmail, setReferrerEmail] = useState("");
  const [referralEmail, setReferralEmail] = useState("");

  const handleTrafficChannelChange = (e) => {
    setTrafficChannel(e.target.value);
  };

  const handleReferrerEmailChange = (e) => {
    setReferrerEmail(e.target.value);
  };

  const handleReferralEmailChange = (e) => {
    setReferralEmail(e.target.value);
  };

  const handleSubmitReferral = (e) => {
    e.preventDefault();

    const referralData = {
      email_address: props.user.user[7].Value,
      referrer: referrerEmail,
      referral: referralEmail,
      trafficChannel: trafficChannel,
    };

    fetch(
      "https://lwqwrndrm7.execute-api.ap-southeast-2.amazonaws.com/api/referral",
      {
        headers: { "Content-Type": "application/json" },
        method: "POST",
        body: JSON.stringify(referralData),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setSubmitted(true);
      });
  };

  return (
    <>
      <Grid mb={2}>
        <Typography variant="h1" sx={{ my: 1 }}>
          Thank you!
        </Typography>
        <Typography variant="h3" sx={{ my: 1 }}>
          One more thing ...
        </Typography>
        <Typography variant="body" sx={{ my: 1 }}>
          You're all signed up, and you should hear from us within a day or two.
          While we've got you...
        </Typography>
      </Grid>
      <Grid container justifyContent={"space-between"}>
        <Grid item>
          <Grid>
            <Typography variant="h4" sx={{ my: 1 }}>
              Referral Credits
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body" sx={{ my: 1, fontWeight: 500 }}>
              How did you hear about us?
            </Typography>
            <FormControl fullWidth>
              <Select
                id="referral"
                name="referral"
                onChange={handleTrafficChannelChange}
                value={trafficChannel}
              >
                <MenuItem value={"Google"}>Google</MenuItem>
                <MenuItem value={"Solar Installer"}>Solar Installer</MenuItem>
                <MenuItem value={"Energy Made Easy"}>Energy Made Easy</MenuItem>
                <MenuItem value={"Wattever"}>Wattever</MenuItem>
                <MenuItem value={"Comparison Site"}>Comparison Site</MenuItem>
                <MenuItem value={"Media"}>
                  Media (TV, Newspaper, Radio)
                </MenuItem>
                <MenuItem value={"Advertisement"}>Advertisement</MenuItem>
                <MenuItem value={"Other"}>Other referral (e.g. club)</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid my={1}>
            <Typography variant="body" sx={{ my: 1, fontWeight: 500 }}>
              Were you referred by a friend? Give us their name or email below
              and you’ll both get a $25 credit!
            </Typography>
            <TextField
              fullWidth
              onBlur={handleReferrerEmailChange}
              onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
            />
          </Grid>
          <Grid my={1}>
            <Typography variant="body" sx={{ my: 1, fontWeight: 500 }}>
              Got a friend who wants to sign up too? Put their name or email
              below and get another $25 for the both of you!
            </Typography>
            <TextField
              fullWidth
              onBlur={handleReferralEmailChange}
              onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
            />
          </Grid>
          <Grid item py={2}>
            <Button
              variant="contained"
              disabled={submitted}
              sx={{
                px: 10,
                fontWeight: "bold",
                borderRadius: "15px",
              }}
              onClick={handleSubmitReferral}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <Grid container my={3}>
        <Grid item lg={12} md={12} sm={12}>
          <Typography variant="h4" sx={{ my: 1 }}>
            Keep up with tips & tricks
          </Typography>
          <Typography variant="body" sx={{ my: 1 }}>
            Keen to keep your power bills as low as possible? Join our facebook
            group for tips and tricks!
          </Typography>
        </Grid>
        <Grid item lg={3} my={1} display="flex" alignItems="center">
          <img
            alt="facebook-icon"
            src={FacebookIcon}
            style={{ width: "10%", my: 2, display: "inline" }}
          ></img>
          <Link
            display="inline"
            my={1}
            ml={2}
            fontWeight="bold"
            sx={{ cursor: "pointer" }}
            href="https://www.facebook.com/groups/792502358400640"
          >
            iO Energy User Group
          </Link>
        </Grid>
      </Grid>
    </>
  );
}

export default Account;
